import * as React from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash';

import { humanize } from '../../../utils/format';
import Select from '../../../components/Select';

import { ReactComponent as EditIcon } from './assets/edit-24.svg';
import { ReactComponent as DeleteIcon } from './assets/delete-24.svg';
import { ReactComponent as PdfView } from './assets/pdf-view-24.svg';
import { ReactComponent as DownloadFileIcon } from './assets/download-file-24.svg';
import * as api from '../api';
import * as fileSaver from 'file-saver';
import DateFormats from '../../../constants/DateFormats';
import ReactTableComponent from '../../../components/ReactTableComponent';
import config from 'config';

export class ChecksTable extends React.Component {
  static propTypes = {
    data: PropTypes.any,
    onView: PropTypes.func,
    onUpdate: PropTypes.func,
    onRemove: PropTypes.func,
    onCategoryChange: PropTypes.func,
    onYearChange: PropTypes.func,
    onSortedChange: PropTypes.func,
    fetchNextPage: PropTypes.func,
    filterCategories: PropTypes.array,
    yearFilter: PropTypes.object,
    filterYears: PropTypes.array,
    categoryFilter: PropTypes.object,
    paginationOptions: PropTypes.object,
    isLoading: PropTypes.bool,
    defaultSorted: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.columns = [
      {
        Header: null,
        accessor: 'receiptId',
        sortable: false,
        resizable: false,
        width: 60,
        Cell: EditCell,
        getProps: (tableState, rowInfo) => ({
          onEditClick: (e) => {
            this.handleEditClick(e, rowInfo.original);
          },
        }),
      },
      {
        Header: 'Дата и время чека',
        accessor: 'originDate',
        minWidth: 160,
        Cell: DateTimeCell,
        filterMethod: (nextFilter, row) => {
          if (nextFilter.value === -1) {
            return true;
          }

          return moment(row.originDate).isSame(moment(nextFilter.value, 'YYYY'), 'year');
        },
      },
      {
        Header: 'Сумма, ₽',
        minWidth: 120,
        accessor: 'originSum',
        Cell: SummaCell,
      },
      {
        Header: 'Описание чека',
        accessor: 'description',
        minWidth: 165,
        getHeaderProps: () => ({
          tooltip: 'Введите краткое описание, чтобы быстрее находить нужный чек.',
        }),
      },
      {
        Header: 'Категория',
        accessor: 'receiptCategory.value',
        minWidth: 140,
        id: 'receiptCategory.title',
        Cell: CategoryCell,
        getHeaderProps: () => ({
          tooltip:
            'Категория поможет упорядочить и подобрать чеки при оформлении налоговых вычетов.',
        }),
        getProps: (tableState, rowInfo) => {
          return {
            title: get(rowInfo, 'original.receiptCategory.label'),
          };
        },
        filterMethod: (nextFilter, row) => {
          if (nextFilter.value === -1) {
            return true;
          }

          return nextFilter.value === get(row, 'receiptCategory.label');
        },
      },
      {
        Header: null,
        accessor: 'receiptId',
        sortable: false,
        resizable: false,
        width: 90,
        Cell: ActionsCell,
        getProps: (tableState, rowInfo) => ({
          onViewClick: (e) => {
            this.handleViewClick(e, rowInfo.original);
          },
          onRemoveClick: (e) => {
            this.handleRemoveClick(e, rowInfo.original);
          },
        }),
      },
    ];
  }

  handleViewClick = (event, data) => {
    event.preventDefault();

    this.props.onView(data);
  };

  handleEditClick = (event, data) => {
    event.preventDefault();

    this.props.onUpdate(data);
  };

  handleRemoveClick = (event, data) => {
    event.preventDefault();

    this.props.onRemove(data);
  };

  handleCsvClick = (e) => {
    e.preventDefault();

    api.unloadCsv().then(({ isOk, data }) => {
      if (isOk) {
        fileSaver.saveAs(data, 'receipts_export.xlsx', true);
      }
    });
  };

  render() {
    const {
      data: tableData,
      filterCategories,
      filterYears,
      paginationOptions,
      isLoading,
    } = this.props;
    return (
      <ReactTableComponent
        columns={this.columns}
        tableData={tableData}
        sortable={true}
        paginationOptions={paginationOptions}
        showPaginationSizeInput
        pageSizeOptions={[10, 25, 50]}
        defaultPageSize={50}
        fetchNextPage={this.props.fetchNextPage}
        defaultFiltered={[this.props.categoryFilter, this.props.yearFilter]}
        defaultSorted={this.props.defaultSorted}
        onSortedChange={this.props.onSortedChange}
        loading={isLoading}
      >
        <div className={'ChecksTable__filters boo'}>
          <div className={'row'}>
            <div className={'col-md-4 mb-2 mb-md-0'}>
              <Select
                value={get(this.props.categoryFilter, 'value', -1)}
                options={filterCategories}
                onChange={this.props.onCategoryChange}
                isRequired={true}
                isFull={true}
                withoutHelpWrapper={true}
              />
            </div>

            <div className={'col-md-4'}>
              <Select
                value={get(this.props.yearFilter, 'value', -1)}
                options={filterYears}
                onChange={this.props.onYearChange}
                isRequired={true}
                isFull={true}
                withoutHelpWrapper={true}
              />
            </div>

            <div className={'col-md-4'}>
              <div className={'right'}>
                <DownloadFileLink onClick={this.handleCsvClick} />
              </div>
            </div>
          </div>
        </div>
      </ReactTableComponent>
    );
  }
}

function DateTimeCell(props) {
  const formatedDate = moment(props.value).format(DateFormats.long_with_short_time_no_comma);
  return <div className={'ChecksTable__date-cell'}>{formatedDate}</div>;
}

DateTimeCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function SummaCell(props) {
  const formatedSumma = humanize(props.value);

  return <div className={'ChecksTable__summa-cell'}>{formatedSumma}</div>;
}

SummaCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function CategoryCell(props) {
  return <div className={'ChecksTable__category-cell'}>{props.columnProps.rest.title}</div>;
}

CategoryCell.propTypes = {
  columnProps: PropTypes.shape({
    rest: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

function EditCell(props) {
  return (
    <div className={'ChecksTable__edit-cell'}>
      {!config.isInspectorArm ? (
        <EditIcon
          className={'ChecksTable__action ChecksTable__edit-action'}
          onClick={props.columnProps.rest.onEditClick}
        />
      ) : null}
    </div>
  );
}

EditCell.propTypes = {
  columnProps: PropTypes.shape({
    rest: PropTypes.shape({
      onEditClick: PropTypes.func.isRequired,
    }),
  }),
};

function ActionsCell(props) {
  return (
    <div className={'ChecksTable__actions-cell'}>
      <PdfView
        className={'ChecksTable__action ChecksTable__view-action'}
        onClick={props.columnProps.rest.onViewClick}
      />
      {!config.isInspectorArm ? (
        <DeleteIcon
          className={'ChecksTable__action ChecksTable__remove-action'}
          onClick={props.columnProps.rest.onRemoveClick}
        />
      ) : null}
    </div>
  );
}

ActionsCell.propTypes = {
  columnProps: PropTypes.shape({
    rest: PropTypes.shape({
      onViewClick: PropTypes.func.isRequired,
      onRemoveClick: PropTypes.func.isRequired,
    }),
  }),
};

function DownloadFileLink({ onClick }) {
  return (
    <a className={'DownloadFileLink'} onClick={onClick}>
      <DownloadFileIcon /> {'Выгрузить чеки в файл'}
    </a>
  );
}

DownloadFileLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};
